import React from "react"

import { ApiResponse } from "shared/types/ApiResponse"
import { FilePreview } from "shared/types/File"
import { AttachmentType } from "shared/types/__generated__/graphql"
import { FileUpload } from "shared/ui/file-upload/FileUpload"

import { AttachmentFragment } from "entities/attachments/graphql/fragments.generated"

interface ReplaceAttachmentOverlayFileInputProps {
  newFile: AttachmentFragment | null
  disabled?: boolean
  onUpload: (file: FilePreview) => Promise<ApiResponse<unknown>>
}

export const ReplaceAttachmentOverlayFileInput = React.memo(
  ({ newFile, disabled, onUpload }: ReplaceAttachmentOverlayFileInputProps) => {
    return (
      <FileUpload.Root
        onUpload={onUpload}
        multiple={false}
        files={newFile as AttachmentType | null}
        isDisabled={disabled}
      >
        {!newFile && <FileUpload.Input variant="minimal" hideDuringUpload />}
        <FileUpload.List />
      </FileUpload.Root>
    )
  }
)
